import ProjectLogsPanel from "./ProjectLogsPanel";

export default ProjectLogsPanel;
